'use client'

import { createContext, useContext } from 'react'

/** Shared links remain usable outside the authenticated application. */
export const RouteCodePreloadContext = createContext<
  ((href: string) => void) | undefined
>(undefined)

export function useRouteCodePreload() {
  return useContext(RouteCodePreloadContext)
}
